import { Button, Card, Text } from "../../../../components";
import styled, { useTheme } from "styled-components";
import React, { useCallback } from "react";
import { Flex } from "antd";

const Section = ({
  children,
  desc = "",
  title = "",
  subtitle = "",
  className = "",
  buttons = [],
} = {}) => {
  const theme = useTheme();

  const renderHeader = useCallback(({ className, vertical, ...props } = {}) => {
    return (
      <Flex
        align="center"
        justify="space-between"
        className={`m-20-b ${className} section-header`}
      >
        <Text
          level={4}
          weight={700}
          type="secondary"
          children={title}
          className="title"
          {...(props.title ?? {})}
        />
        {!!subtitle && (
          <Text
            level={4}
            weight={700}
            children={subtitle}
            className="subtitle"
            {...(props.subtitle ?? {})}
          />
        )}
      </Flex>
    );
  }, []);

  return (
    <Styled
      className={className}
      classNames={{ body: "p-20" }}
      style={{ background: theme.token.surface.primary }}
    >
      {(!!title || !!subtitle) && (
        <Flex
          align="center"
          justify="space-between"
          className={`m-20-b section-header`}
        >
          <Text
            level={4}
            weight={700}
            type="secondary"
            children={title}
            className="title"
          />
          {!!subtitle && (
            <Text
              level={4}
              weight={700}
              children={subtitle}
              className="subtitle"
            />
          )}
        </Flex>
      )}
      {!!desc && <Text type="secondary" children={desc} />}
      {!!buttons.length && (
        <Flex
          className="m-30-t"
          children={React.Children.toArray(
            buttons.map((button) => <Button type="primary" {...button} />)
          )}
        />
      )}
      {children}
    </Styled>
  );
};

const Styled = styled(Card)`
  .section-header {
    ${(_) => _.theme.mobile(`display: block`)}
    .title {
      ${(_) => _.theme.mobile(`font-size: 1.6rem`)}
    }
    .subtitle {
      ${(_) =>
        _.theme.mobile(`
        font-size: 3rem;
        line-height: 3rem !important;
        margin-top: .3rem !important;
      `)}
    }
  }
`;

export default Section;
